import React from 'react'
import { parseBBCode } from '../../../libraries/BBCode'
import { getTabDecor, getHistoriaSectionDecor } from './archiveTabs'
import { publicAsset } from './hanBanner'

const SCROLL_TEXTURE = publicAsset('/single_scroll.jpg')

export default function HanArchiveSection({ section, isHistoriaPart = false }) {
  const tabDecor = getTabDecor(section.id)
  const historiaDecor = getHistoriaSectionDecor(section.id)
  const isCapitulo = section.id?.startsWith('historia-capitulo-')
  const decor = isHistoriaPart || section.id.startsWith('historia-')
    ? { kanji: '史', num: isCapitulo ? section.baseTitle || '' : historiaDecor.num }
    : tabDecor
  const headingText = isCapitulo ? section.subtitle || '' : section.title
  const headingId = `han-archives-heading-${section.id}`
  const sectionLabelledBy = headingText || (isCapitulo && decor.num) ? headingId : undefined

  return (
    <section
      id={section.id}
      className="han-archives-section"
      aria-labelledby={sectionLabelledBy}
    >
      <div
        className="han-archives-section__panel"
        style={{ '--han-scroll-texture': `url("${SCROLL_TEXTURE}")` }}
      >
        <header className="han-archives-section__header">
          <span className="han-archives-section__kanji" aria-hidden="true">
            {decor.kanji}
          </span>
          <div className="han-archives-section__heading">
            {decor.num ? (
              <span
                id={isCapitulo && !headingText ? headingId : undefined}
                className="han-archives-section__num"
              >
                {decor.num}
              </span>
            ) : null}
            {headingText ? (
              <h2 id={headingId} className="han-archives-section__title">
                {headingText}
              </h2>
            ) : null}
          </div>
        </header>

        <div
          className="han-archives-section__body story-text story-bbcode"
          dangerouslySetInnerHTML={{ __html: parseBBCode(section.content || '') }}
        />
      </div>
    </section>
  )
}
